export default __webpack_public_path__ + "static/media/winguenterprises.16dc3105.png";